import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, create, update, getList, setPaginaAtual } from './controladorActions';

import List from './controladorList';
import Form from './controladorForm';
import ListControladorFase from './controladorFaseList';
import ListControladorSAP from './controladorSAP';
import PermissaoUsuario from '../auth/permissao';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SemaphoreLoading from '../common/loading/semaphoreLoading';

class Controlador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: '',
    };
    this.cancelarAlteracaoHandler = null;
    this.changeGrupo = this.changeGrupo.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.registerCancelarAlteracao = this.registerCancelarAlteracao.bind(this);
    this.handleCloseTabUpdate = this.handleCloseTabUpdate.bind(this);
  }

  componentWillMount() {
    this.props.init();
  }

  changeGrupo() {
    this.props.getList();
    this.props.setPaginaAtual(0);
  }

  async handleSubmit(values) {
    this.setState({
      loading: true,
      loadingMessage:
        'Atualizando controlador, anéis, planos e fases...<br/><small>Aguarde, este processo é longo e pode levar algum tempo.</small>',
    });

    try {
      if (values.id) {
        await this.props.update(values);
      } else {
        await this.props.create(values);
      }
    } finally {
      this.setState({ loading: false, loadingMessage: '' });
    }
  }

  registerCancelarAlteracao(handler) {
    this.cancelarAlteracaoHandler = handler;
  }

  handleCloseTabUpdate() {
    if (this.cancelarAlteracaoHandler) {
      this.cancelarAlteracaoHandler();
    }
  }

  render() {
    const selectStyle = {
      height: '38px',
      padding: '7px 10px',
      fontSize: '13px',
      fontWeight: '500',
      border: '1px solid #bfd0e0',
      borderRadius: '10px',
      backgroundColor: '#ffffff',
      color: '#475569',
      boxShadow: 'none',
    };

    return (
      <div>
        <SemaphoreLoading show={this.state.loading} message={this.state.loadingMessage} />
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadControlador" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
              </PermissaoUsuario>
              <TabHeader
                label="Alterar"
                icon="pencil-alt"
                target="tabUpdate"
                closeAction={true}
                onCloseClick={this.handleCloseTabUpdate}
              />
              {/* <TabHeader label='Configurar Fases' icon='traffic-light' target='tabFase' /> */}
              <TabHeader label="Seleção Automática de Planos" icon="car" target="tabSAP" />
              {/* <TabHeader label='Planos' icon='sitemap' target='tabPlano' /> */}
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  >
                    Grupo Físico:
                  </label>
                  <SelectConfGrupoFisico onChange={this.changeGrupo} customStyle={{ ...selectStyle, width: '200px' }} />
                </div>
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.handleSubmit} submitClass="primary" submitLabel="Salvar" premiumLayout={true} />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form
                  onSubmit={this.handleSubmit}
                  readOnly={true}
                  submitClass="primary"
                  submitLabel="Salvar"
                  premiumLayout={true}
                  registerCancelarAlteracao={this.registerCancelarAlteracao}
                />
              </TabContent>
              <TabContent id="tabFase">
                <ListControladorFase />
              </TabContent>
              <TabContent id="tabSAP">
                <ListControladorSAP />
              </TabContent>
              <TabContent id="tabPlano">
                <Form onSubmit={this.handleSubmit} readOnly={false} submitClass="primary" submitLabel="Salvar" />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update, getList, setPaginaAtual }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(Controlador);
